import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { translateDataToTree } from "../utils/translateTree";

const getDefaultState = () => ({
  data: null
})

export default new Vuex.Store({
  state: {
    worktab: {
      list: [
        {
          name: 'homepage',
          tabname: '主页',
          path: '/home/page',
          closable: false
        }
      ],
      current: {
        name: 'homepage',
        tabname: '主页',
        path: '/home/page',
        closable: false
      }
    },
    name: "" || localStorage.name,
    token: "" || localStorage.token,
    avatar: "" || localStorage.avatar,
    menu: localStorage.route ? JSON.parse(localStorage.route) : [],
    role: "" || localStorage.role
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getMenu(state) {
      return translateDataToTree(state.menu);
    },
    getRole(state) {
      return state.role;
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    SET_NAME(state, name) {
      state.name = name;
      localStorage.setItem('name', name);
    },
    SET_AVATAR(state, avatar) {
      state.avatar = avatar;
      localStorage.setItem('avatar', avatar);
    },
    SET_ROUTE(state, route){
      state.menu = route;
      localStorage.setItem('route', JSON.stringify(route));
    },
    SET_ROLE(state, role) {
      state.role = role;
      localStorage.setItem('role', role);
    },
    RESET_DATA(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    resetData({ commit }){
      commit('RESET_DATA')
    }
  },
  modules: {
  }
})
